import type { BuildingTypeKeys } from "./get_trade_measure.ts";
import { BASEURL, Request, TRequestMethod } from "./request.ts";
import { Schema, type SchemaObject } from "./validation.ts";

export interface ESRBasicDataResponse{
	"heating_demand_kwh":number;
	"electricity_consumption_kwh":number;
    "region_name": string;
}


const ESRBasicDataResponseSchema : SchemaObject = {
	"heating_demand_kwh":'number',
	"electricity_consumption_kwh":'number',
    "region_name": "string",
}

export class ESRBasicData extends Request<ESRBasicDataResponse>{
    override method : TRequestMethod = "POST";
    override responseSchema : Schema = ESRBasicDataResponseSchema;

    constructor (
        public sessionToken: string,
        public building_type: BuildingTypeKeys,
        public construction_year: number,
        public zip: number,
        public living_area: number,
        public number_of_units:  number,
        public number_of_floors: number,
        public heating_type: string,
        public country_code: string,
        public roof_heated_area: number,
        public living_heated_area: number,
        public basement_heated_area: number,
        public private_residential_property: number,
    ){
        super();
    }

    override route() : string{
        return `${BASEURL}/basic_data?sessionToken=${this.sessionToken}`;
    }
}